var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
/** @jsxImportSource theme-ui */
import Box from "../Grid/Box";
import SemiTitle from "../Text/SemiTitle";
export default function Section(_a) {
    var { children, title } = _a, rest = __rest(_a, ["children", "title"]);
    return (_jsxs(Box, Object.assign({ as: "section", sx: { marginY: 4 } }, rest, { children: [title && _jsx(SemiTitle, { children: title }), children] })));
}
Section.Title = SemiTitle;
//# sourceMappingURL=Section.js.map